import React, { useEffect, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import ProductSummary from './ReusableComponents/ProductSummary';
import ProductDescription from './ReusableComponents/ProductDescription';
import {
  isEmptyObject,
  jsontoObjects,
  getFullImagePath,
  getTernaryValue,
  getLength,
  getAndCheck,
  getValueOrDefaultObject,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';
import ProductListingModalOptions from 'organisms/ProductListingModalOptions/Container/ProductListingModalOptionsComponent';
import ImageComponent from 'atoms/Image';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ViewMenuLink from './ViewMenuLink';
import RecommendedContainer from 'organisms/RecommendedComponent/Container/RecommendedContainer';
import { RECOMMENDED_CONSTANTS } from 'organisms/RecommendedComponent/Constants/RecommendedComponentConstant';

/* method to segregate recommended data & make it a combo data */
export const getComboAndRecommendationData = (recommendationRules, UPSELL, CROSSELL) => {
  let data = {
    combo: [],
    recommendation: [],
  };
  if (getLength(recommendationRules)) {
    let combo = recommendationRules.find(({ recommendationType }) => recommendationType === UPSELL);
    let recommendation = recommendationRules.find(({ recommendationType }) => recommendationType === CROSSELL);
    data.combo = getTernaryValue(isEmptyObject(combo), combo?.recommendedItems, []);
    data.recommendation = getTernaryValue(isEmptyObject(recommendation), recommendation?.recommendedItems, []);
  }
  return data;
};
/* method to return pdpProductImage html */
export const pdpProductImage = (isFromPlp, pdpData, tenantData, isMobile) => {
  return (
    <>
      {!isFromPlp && <ViewMenuLink redirectLink={'/menu'} />}
      <ImageComponent
        defaultPath={getFullImagePath(null, tenantData, true)}
        srcFile={getFullImagePath(pdpData.imageName, tenantData)}
        className={`${isMobile ? 'pdp-product-mobile-image' : 'pdp-product-image'}`}
      />
    </>
  );
};

const MenuPdpItem = props => {
  const { productDetails, tenantData, isMobile, displayBreadcrumbPDP, isIpad, product_name } = props;
  const { ADD_TO_CART_CLICK, DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const { CUSTM_EXPAND_TYPE, MAKE_IT_COMBO_HEADER, MAKE_IT_COMBO_SUBHEADER, UPSELL, CROSSELL, PDP } =
    MENU_PDP_PAGE_CONSTANTS;
  const { RECOMMENDED_HEADER_TITLE } = RECOMMENDED_CONSTANTS;

  const { isFromPlp = false } = getValueOrDefaultObject(productDetails);
  const [pdpData, setPdpData] = useState({});
  const [modifierGrp, setModifierGroup] = useState();
  const [modifiedPrice, setModifiedPrice] = useState(0);
  const [makeItAComboData, setMakeItAComboData] = useState([]);
  const [recommendationData, setRecommendationData] = useState([]);
  const [currentPDPProduct, setCurrentPDPProduct] = useState({});
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const currentItemObject = useSelector(({ menuReducer: { currentItemDetails } }) => currentItemDetails);

  useEffect(() => {
    userOrderStateDispatch({ type: CUSTM_EXPAND_TYPE, value: 'single' });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getAndCheck(isEmptyObject(currentItemObject), currentItemObject?.url === product_name)) {
      const { additionalProperties } = currentItemObject;
      const addnProps = jsontoObjects(additionalProperties) || {};
      setPdpData({
        ...currentItemObject,
        additionalProperties: addnProps,
        quantityAddedCart: productDetails?.quantity,
        catalogName: productDetails.catalogName,
        itemId: productDetails.productId,
      });
      let comboAndRecommendation = getComboAndRecommendationData(
        currentItemObject?.recommendationRules,
        UPSELL,
        CROSSELL,
      );
      setMakeItAComboData(comboAndRecommendation.combo);
      setRecommendationData(comboAndRecommendation.recommendation);
      setCurrentPDPProduct(currentItemObject);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(currentItemObject)]);

  const recommendationRulesTemplate = (flag, productList, header, subHeader, cssClass) => (
    <RecommendedContainer
      products={productList}
      country={tenantData?.country}
      cssClass={cssClass}
      header={header}
      subHeader={subHeader}
      recommendedRule={flag}
      source={PDP}
    />
  );
  const getUpdatedModifier = data => {
    const { modifierGrp = {}, modifiedItemPrice = 0 } = data;
    setModifierGroup(modifierGrp);
    setModifiedPrice(modifiedItemPrice);
  };

  const addtoCartClinckHandler = () => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    userOrderStateDispatch({
      type: ADD_TO_CART_CLICK,
      value: {
        addToCart: true,
        productItemId: productDetails.productId,
        categoryId: productDetails.categoryId,
        oldProduct: productDetails.productInfo,
        customizable: productDetails.customizable,
        catalogs: productDetails.catalogName,
        fromPdpPage: true,
      },
    });
  };

  const pdpSummaryView = () => {
    return (
      <>
        <ProductSummary
          pdpData={pdpData}
          isMobile={isMobile}
          isIpad={isIpad}
          addtoCartClinckHandler={addtoCartClinckHandler}
          customModGrps={modifierGrp}
          modifiedPrice={modifiedPrice}
          categoryId={productDetails.categoryId}
          comboData={makeItAComboData?.length}
          categoryName={productDetails.categoryName}
          categoryUrl={productDetails.categoryUrl}
        />
      </>
    );
  };

  const productImgAndSummaryMobView = () => {
    return (
      isMobile && (
        <div className='pdp-mobile-image-container'>
          {pdpProductImage(isFromPlp, pdpData, tenantData, isMobile)}
          <div className='pdp-mobile-navigation'>{displayBreadcrumbPDP}</div>
          {currentPDPProduct.modgrps && pdpSummaryView()}
        </div>
      )
    );
  };

  const productImgAndSummaryDesktopView = () => {
    return (
      !isMobile && (
        <div className='d-flex'>
          <div className='image-container'>{pdpProductImage(isFromPlp, pdpData, tenantData, isMobile)}</div>
          {currentPDPProduct.modgrps && pdpSummaryView()}
        </div>
      )
    );
  };
  return isEmptyObject(pdpData) && isEmptyObject(currentPDPProduct) && isEmptyObject(tenantData) ? (
    <>
      {!isMobile && <div className='pdp-navigation'>{displayBreadcrumbPDP}</div>}
      <div className={`${(isMobile && 'pdp-mobile-container ' ) || 'pdp-details-container'}`}>
        {productImgAndSummaryDesktopView()}
        {productImgAndSummaryMobView()}
      </div>
      <div className={`pdp-desc-container pdp-desc-container-in ${(isMobile && 'mobile') || ''}`}>
        {!!isEmptyObject(currentPDPProduct) && (
          <div className='d-flex'>
            <ProductDescription
              shortDescription={currentPDPProduct.shortDescription}
              longDescription={currentPDPProduct.longDescription}
              isMobile={isMobile}
              tenantData={tenantData}
            />
          </div>
        )}
      </div>
      {pdpData.customizable && (
        <div className={`pdp-custm-container ${getTernaryValue(isMobile, 'mobile', '')} pdp-custm-container-in`}>
          <div className='d-flex'>
            <ProductListingModalOptions
              data={currentPDPProduct}
              isModal={false}
              showPriceContent={false}
              isMobile={isMobile}
              callBackToPDP={getUpdatedModifier}
              source={PDP}
            />
          </div>
        </div>
      )}
      {getAndCheck(makeItAComboData?.length > 0, !currentPDPProduct.customizable) &&
        recommendationRulesTemplate(
          UPSELL,
          makeItAComboData,
          translateWithI18Next(MAKE_IT_COMBO_HEADER),
          translateWithI18Next(MAKE_IT_COMBO_SUBHEADER),
          'pdp-combo',
        )}
      {recommendationData?.length > 0 &&
        recommendationRulesTemplate(CROSSELL, recommendationData, RECOMMENDED_HEADER_TITLE, '', 'pdp-recommendations')}
    </>
  ) : (
    <div className='d-flex justify-content-center'>{translateWithI18Next('turnedNoResult')}</div>
  );
};

export default MenuPdpItem;
